import React from 'react';
import PublicLayout from './PublicLayout';

const FEATURES = [
  { title: 'Single sign-on (SSO)', desc: 'SAML 2.0 / OIDC integration with your IdP (Okta, Azure AD, Google Workspace).' },
  { title: 'Role hierarchy', desc: 'Super-agent → senior-agent → junior-agent. Location-scoped permissions. Audit log of every change.' },
  { title: 'Bulk operations', desc: 'CSV upload for workers and shifts. Bulk archive, restore, assign. API access for headless integrations.' },
  { title: 'Custom reporting', desc: 'Exports to CSV/PDF. Saved-query templates. Optional warehouse export (Snowflake, BigQuery).' },
  { title: 'Dedicated support', desc: 'Implementation manager. 4-hour P0 SLA. Quarterly business review.' },
  { title: 'BAA + DPA', desc: 'HIPAA Business Associate Agreement and EU Data Processing Addendum signed at contract.' },
];

export default function EnterprisePage() {
  return (
    <PublicLayout title="Enterprise" eyebrow="For larger organizations">
      <p className="lead">When you're staffing 100+ workers across multiple locations, the basics aren't enough. Enterprise is built for state-level operators, multi-site agencies, and hospital networks.</p>
      <div className="not-prose grid sm:grid-cols-2 gap-4 my-8">
        {FEATURES.map((f, i) => (
          <div key={f.title} className="bg-white border border-slate-200 rounded-xl p-5" data-testid={`enterprise-feature-${i}`}>
            <h3 className="text-lg font-semibold text-slate-900">{f.title}</h3>
            <p className="text-sm text-slate-600 mt-2">{f.desc}</p>
          </div>
        ))}
      </div>
      <h2>Pricing</h2>
      <p>Enterprise plans start at $2,500/month with custom volume tiers for multi-location operators. Per-shift fees scale down with volume.</p>
      <h2>Talk to sales</h2>
      <p>Tell us about your operation and we'll put together a proposal within one business day. <a href="/contact">Contact form →</a> or <a href="mailto:sales@scensobconnect.com">sales@scensobconnect.com</a>.</p>
    </PublicLayout>
  );
}
